/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfittitle2Inputs */

const en_coverfittitle2 = /** @type {(inputs: Coverfittitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust cover with AI`)
};

const de_coverfittitle2 = /** @type {(inputs: Coverfittitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild mit KI anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust cover with AI" |
*
* @param {Coverfittitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfittitle2 = /** @type {((inputs?: Coverfittitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfittitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfittitle2(inputs)
	return de_coverfittitle2(inputs)
});
export { coverfittitle2 as "coverFitTitle" }